import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Row, Col, Input, Form, Select, InputNumber } from '@duxton-web/ui';
import ReadOnlyForm from './ReadOnlyForm';
import { PROMO_REDEEMED_IDENTIFIERS, SPLIT_CONDITIONS } from '../utils/constants';

const getPromoRedeemedKey = (props) => {
  if (_.get(props, 'node.data.param.promoCode', '')) {
    return PROMO_REDEEMED_IDENTIFIERS.promoCode;
  }
  return PROMO_REDEEMED_IDENTIFIERS.promoID;
};

const SplitForm = (props) => {
  const [promoRedeemedKey, setPromoRedeemedKey] = useState(getPromoRedeemedKey(props));
  const [splitFuncName, setSplitFuncName] = useState(_.get(props, 'node.data.func', ''));
  useEffect(() => {
  }, [props.node]);

  const conditions = [
    { value: SPLIT_CONDITIONS.messageOpened, label: 'Communication opened' },
    { value: SPLIT_CONDITIONS.promoRedeemed, label: 'Promo redeemed' },
    { value: SPLIT_CONDITIONS.martCompleted, label: 'GM transaction completed' },
  ];

  const conditionValues = [
    { value: 'true', label: 'TRUE' },
    { value: 'false', label: 'FALSE' },
  ];

  const promoRedeemedKeyChange = (value) => {
    const { form, node } = props;
    form.current.setFieldValue([node.id, 'data', 'param', PROMO_REDEEMED_IDENTIFIERS.promoID], undefined);
    form.current.setFieldValue([node.id, 'data', 'splts', PROMO_REDEEMED_IDENTIFIERS.promoCode], undefined);
    setPromoRedeemedKey(value);
  };

  const conditionChange = (value) => {
    const { form, node, refreshDiagram } = props;
    form.current.setFieldValue([node.id, 'data', 'splits', '0'], value);
    form.current.setFieldValue([node.id, 'data', 'splits', '1'], `${!(value === 'true')}`);
    if (refreshDiagram) refreshDiagram();
  };

  const inputComponent = promoRedeemedKey === PROMO_REDEEMED_IDENTIFIERS.promoID
    ? <InputNumber style={{ marginLeft: 5, width: '100%', height: 40 }} />
    : <Input style={{ marginLeft: 5 }} />;

  return (
    <div className="jb-form-split">
      <h4>1. 1st Condition</h4>
      <Row>
        <Col span={24}>
          <Form.Item label="Rule #1" name={[props.node.id, 'data', 'func']}>
            <Select onChange={setSplitFuncName} options={conditions} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input value="is" disabled />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label="" name={[props.node.id, 'data', 'splits', '0']}>
            <Select onChange={conditionChange} options={conditionValues} />
          </Form.Item>
        </Col>
      </Row>
      {splitFuncName === SPLIT_CONDITIONS.promoRedeemed &&
        <Row style={{ marginTop: 10 }}>
          <Col span={24}>
            <h4 style={{ marginBottom: 8 }}>Promo details</h4>
          </Col>
          <Col span={12}>
            <Select
              style={{ width: '100%' }} value={promoRedeemedKey} onChange={promoRedeemedKeyChange} options={[
                { value: PROMO_REDEEMED_IDENTIFIERS.promoID, label: 'Promo ID' },
                { value: PROMO_REDEEMED_IDENTIFIERS.promoCode, label: 'Promo Code' },
              ]}
            />
          </Col>
          <Col span={12}>
            <Form.Item label="" name={[props.node.id, 'data', 'param', promoRedeemedKey]}>
              {inputComponent}
            </Form.Item>
          </Col>
        </Row>
      }
      <Row>
        <Col span={24} style={{ marginTop: 15 }}>
          <span className="next-step">Next step</span>
          <ReadOnlyForm node={props.nextNodes[0]} />
        </Col>
      </Row>

      <h4>2. Else</h4>
      <Row>
        <Col span={24}>
          <span>When the user do not match the conditions above </span>
        </Col>
        <Col span={24}>
          <Form.Item label="" name={[props.node.id, 'data', 'splits', '1']}>
            <Select disabled options={conditionValues} />
          </Form.Item>
        </Col>
        <Col span={24} style={{ marginTop: 15 }}>
          <span className="next-step">Next step</span>
          <ReadOnlyForm node={props.nextNodes[1]} />
        </Col>
      </Row>
    </div>
  );
};

export default SplitForm;
